import { EventRegistry } from '../../../../../domain/event/event.registry';
import { AssetEvent } from './asset.event';
export class LegacyPhotosLinkedToAssetEventV2 extends AssetEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset-class/${payload.assetClassId}/asset/${payload.id}`,
            type: LegacyPhotosLinkedToAssetEventV2.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
LegacyPhotosLinkedToAssetEventV2.type = 'com.treeplotter.api.asset.legacyPhotosLinkedToAsset.v2';
EventRegistry.register(LegacyPhotosLinkedToAssetEventV2.type, LegacyPhotosLinkedToAssetEventV2);
//# sourceMappingURL=legacy-photos-linked-to-asset-v2.event.js.map